import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ApiClientService {

	constructor(private http: HttpClient) {
	}

	createAuthorizationHeader(token: string) {
		return new HttpHeaders({
			'Content-Type': 'application/json',
			'Authorization': `${token}`
		});
	}

	get(url: string, token?: string): Observable<any> {
		const headers = this.createAuthorizationHeader(token!);
		return this.http.get(url, {
			headers: headers
		});
	}

	post(url: string, data: any, token: string) {
		const headers = this.createAuthorizationHeader(token);
		return this.http.post(url, data, {
			headers: headers
		});
	}

	put(url: string, data: any, token: string) {
		const headers = this.createAuthorizationHeader(token);
		return this.http.put(url, data, {
			headers: headers
		});
	}

	delete(url: string, token: string) {
		const headers = this.createAuthorizationHeader(token);
		return this.http.delete(url, {
			headers: headers
		});
	}
}
